import { Injectable } from "@angular/core";
import { Actions} from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { SedEventsService } from "../../services/sed-events.service";

@Injectable()
export class SedEventsEffects {
      constructor(
        private actions$: Actions,
        private sedEventsService: SedEventsService,
        private store : Store
      ) {}
}